<template>
  <vuestic-widget :headerText="$t(`trip.edit.title`)">
    <div class="va-row">
      <div class="form-group with-icon-right">
        <div class="input-group tripTitle">
          <input autocomplete="off" v-model="tripData.title" id="trip-name" name="trip-name"/>
          <label
            class="control-label placeholder-label"
            for="trip-name"
            role="button"
          >{{$t("trip.create.nameTitle")}}</label>
          <i class="bar"></i>
        </div>
      </div>
      <div>
        <vuestic-simple-select
          :label="$t('trip.create.status')"
          v-model="statusOption"
          data-vv-name="status"
          v-validate="'required'"
          data-vv-validate-on="change|input"
          option-key="name"
          v-bind:options="statusList"
          class="tripStatus"
        ></vuestic-simple-select>
        <small v-show="errors.has('status')" class="help text-danger">
          {{ errors.first('status') != null ? errors.first('status').replace('status', $t('trip.create.status').toLowerCase()) : ""
          }}
        </small>
      </div>
      <div class="form-group">
        <div class="input-group">
          <vuestic-simple-select
            :label="$t('general.price')"
            :clearable="false"
            v-model="currency"
            data-vv-name="currency"
            v-validate="'required'"
            data-vv-validate-on="change|input"
            :options="currencyList"
            option-key="id"
          ></vuestic-simple-select>
        </div>
      </div>
    </div>
    <div class="va-row">
      <div class="form-group">
        <div class="input-group">
          <vuestic-date-picker
            id="tripDurationFrom"
            :config="config.tripDateFrom"
            ref="tripDurationFrom"
            v-model="startDate"
            v-validate="'required'"
            data-vv-name="tripDurationFrom"
            data-vv-validate-on="change|input"
            @on-change="onTripDateFromChange"
          />
          <label class="control-label" for="tripDurationFrom">{{ $t('trip.create.durationFrom') }}</label>
          <i class="bar"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <vuestic-date-picker
            id="tripDurationTo"
            :config="config.tripDateTo"
            ref="tripDurationTo"
            v-model="endDate"
            v-validate="'required'"
            data-vv-name="tripDurationTo"
            data-vv-validate-on="change|input"
            @on-change="onTripDateToChange"
          />
          <label class="control-label" for="tripDurationTo">{{ $t('trip.create.durationTo') }}</label>
          <i class="bar"></i>
        </div>
      </div>
    </div>
    <div class="va-row" >
      <div class="form-group with-icon-right participants textInput">
        <div class="input-group">
          <input
            data-vv-name="participantsNumber"
            v-model="tripData.participants"
            data-vv-validate-on="blur"
            v-validate="{ required: true, regex: /^(?=.*[1-9])\d+(\.\d+)?$/ }"
            required
          />
          <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa fa-check valid-icon icon-right input-icon"></i>
          <label class="control-label">{{'trip.create.participants' | translate}}</label>
          <i class="bar"></i>
          <small
            v-show="errors.has('participantsNumber')"
            class="help text-danger"
          >{{ errors.first('participantsNumber') != null ? errors.first('participantsNumber').replace('participantsNumber',$t('trip.create.participants').toLowerCase()) : "" }}</small>
        </div>
      </div>
      <div class="form-group with-icon-right minimumParticipants">
        <div class="input-group">
          <input
            data-vv-name="minimumParticipants"
            v-model="tripData.minimumParticipants"
            data-vv-validate-on="blur"
            v-validate="{ required: true, regex: /^(?=.*[1-9])\d+(\.\d+)?$/ }"
            required
          />
          <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
          <i class="fa fa-check valid-icon icon-right input-icon"></i>
          <label class="control-label">{{'trip.create.minimumParticipants' | translate}}</label>
          <i class="bar"></i>
          <small
            v-show="errors.has('minimumParticipants')"
            class="help text-danger"
          >{{ errors.first('minimumParticipants') != null ? errors.first('minimumParticipants').replace('minimumParticipants',$t('trip.create.minimumParticipants').toLowerCase()) : "" }}</small>
        </div>
      </div>
      <div class="">
        <vuestic-simple-select
          :label="$t('trip.create.parish')"
          v-model="parishOption"
          data-vv-name="parish"
          v-validate="'required'"
          data-vv-validate-on="change|input"
          option-key="name"
          v-bind:options="parishList"
          class="tripParish"
        ></vuestic-simple-select>
        <small v-show="errors.has('parish')" class="help text-danger">
          {{ errors.first('parish') != null ? errors.first('parish').replace('parish', $t('trip.create.parish').toLowerCase()) : ""
          }}
        </small>
      </div>
    </div>
    <div class="form-group va-row pb-4">
      <div class="textInput">
        <input
          data-vv-name="singlePrice"
          v-model="tripData.price"
          v-validate="'required|numeric:point'"
          data-vv-validate-on="blur"
          required
        />
        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
        <i class="fa fa-check valid-icon icon-right input-icon"></i>
        <label class="control-label">{{'trip.create.priceField' | translate}}</label>
        <i class="bar"></i>
        <small
          v-show="errors.has('singlePrice')"
          class="help text-danger"
        >{{ errors.first('singlePrice') != null ? errors.first('singlePrice').replace('singlePrice',$t('trip.create.priceField').toLowerCase()) : "" }}</small>
      </div>
      <div class="md3 flex no-padding currency">{{ $t("general.currency." + tripCurrency + ".long") }}</div>
    </div>
    <div class="form-group va-row">
      <div class="textInput">
        <input
          class
          data-vv-name="deposit"
          v-model="tripData.deposit"
          data-vv-validate-on="blur"
          v-validate="'numeric:point'"
          required
        />
        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
        <i class="fa fa-check valid-icon icon-right input-icon"></i>
        <label class="control-label">{{'trip.create.depositField' | translate}}</label>
        <i class="bar"></i>
        <small
          v-show="errors.has('deposit')"
          class="help text-danger"
        >{{ errors.first('deposit') != null ? errors.first('deposit').replace('deposit',$t('trip.create.depositField').toLowerCase()) : "" }}</small>
      </div>
      <div class="md3 flex no-padding currency">{{ $t("general.currency." + tripCurrency + ".long") }}</div>
    </div>
    <div class="form-group form-group-w-btn va-row">
      <div class="flex md3 text-center">
        <label>{{$t('trip.create.templateFiled')}}</label>
        <button class="btn btn-secondary info-btn" @click="showModal()">
          <i class="ion-md-information-circle ion"></i>
        </button>
        <div v-if="!!tripData.tripContractTemplate">
          <button
            @click="downloadDocument(tripData.tripContractTemplate)"
            class="btn btn-secondary btn-micro mr-2"
          >{{ $t('traveller.download') }}</button>
          <button
            @click="deleteFile('tripContractTemplate')"
            class="btn btn-secondary btn-micro"
          >{{ $t('traveller.delete') }}</button>
        </div>
        <div v-else>
          <vuestic-file-upload
            type="single"
            :file-types="'.docx'"
            data-vv-name="tripContractTemplate"
            v-model="tripContractTemplateStorage"
          />
        </div>
      </div>
      <div class="flex md3 text-center">
        <label>{{$t('trip.create.documentFiled')}}</label>
        <div v-if="!!tripData.tripDetails">
          <button
            @click="downloadDocument(tripData.tripDetails)"
            class="btn btn-secondary btn-micro mr-2"
          >{{ $t('traveller.download') }}</button>
          <button
            @click="deleteFile('tripDetails')"
            class="btn btn-secondary btn-micro"
          >{{ $t('traveller.delete') }}</button>
        </div>
        <div v-else>
          <vuestic-file-upload
            type="single"
            :file-types="'.docx,.pdf'"
            v-model="tripDetailsStorage"
            data-vv-name="tripDetailsStorage"
          />
        </div>
      </div>
    </div>
    <div class="form-group va-row">
      <div class="dropDownInput">
        <vuestic-simple-select
          :label="$t('trip.create.destinationField')"
          v-model="destinationOption"
          data-vv-name="destination"
          v-validate="'required'"
          data-vv-validate-on="change|input"
          option-key="name"
          v-bind:options="destinationList"
        ></vuestic-simple-select>
        <small v-show="errors.has('destination')" class="help text-danger">
          {{ errors.first('destination') != null ? errors.first('destination').replace('destination', $t('trip.create.destinationField').toLowerCase()) : ""
          }}
        </small>
      </div>
    </div>
    <div class="form-group va-row">
      <div class="dropDownInput">
        <vuestic-simple-select
          :label="$t('general.passportField')"
          v-model="requirePassport"
          name="mandatoryPassport"
          data-vv-name="mandatoryPassport"
          v-validate="'required'"
          data-vv-validate-on="change|input"
          ref="mandatoryPassport"
          v-bind:options="mandatoryOptions"
          option-key="label"
        ></vuestic-simple-select>
        <small
          v-show="errors.has('mandatoryPassport')"
          class="help text-danger"
        >{{ errors.first('mandatoryPassport') != null ? errors.first('mandatoryPassport').replace('mandatoryPassport', $t('general.passportField').toLowerCase()) : "" }}</small>
      </div>
    </div>
    <div class="form-group va-row">
      <div class="dropDownInput">
        <vuestic-simple-select
          :label="$t('general.visaField')"
          v-model="requireVisa"
          name="mandatoryVisa"
          data-vv-name="mandatoryVisa"
          v-validate="'required'"
          data-vv-validate-on="change|input"
          ref="mandatoryVisa"
          v-bind:options="mandatoryOptions"
          option-key="label"
        ></vuestic-simple-select>
        <small
          v-show="errors.has('mandatoryVisa')"
          class="help text-danger"
        >{{errors.first('mandatoryVisa') != null ? errors.first('mandatoryVisa').replace('mandatoryVisa', $t('general.visaField').toLowerCase()) : "" }}</small>
      </div>
    </div>
    <!--//Modals-->
    <vuestic-modal
      ref="smallModal"
      v-bind:medium="true"
      :cancelClass="'none'"
      :okText="'modal.confirm' | translate"
      :cancelText="'modal.cancel' | translate"
    >
      <div slot="title">{{'modal.info' | translate}}</div>
      <p>
        Моля, използвайте следната таблица с кодове, когато създавате шаблон за договор. На всяко място където 
        изпозлвате кода в договара, системата ще се опита да постави стойност от профила на потребителя или от данните за пътуването, ако такава съществува.
        Форматирането на самия договор ще се запази. При натискане на бутона се копира съответния код и той трябва да се вмъкне в договора. 
        </p>
        <p>

         Това ще помогне за правилното генериране на договори
         за всеки клиент и ще спести значително време от ръчното попълване на данни за всеки потребител.
      </p>
      <div class="table-responsive">
        <table class="table table-striped first-td-padding">
          <thead>
            <tr>
              <td class="filters-page__table-heading">{{'modal.placeholder' | translate}}</td>
              <td class="filters-page__table-heading">{{'modal.explanation' | translate}}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('name')">Имена</button>
              </td>
              <td>Пълно име</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('nameLatin')">Латински имена</button>
              </td>
              <td>Пълно име на латински</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('identityNumber')">ЕГН</button>
              </td>
              <td>ЕГН</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('phone')">телефон</button>
              </td>
              <td>Телефон</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('email')">email</button>
              </td>
              <td>email</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('identityCardNumber')">Лична Карта</button>
              </td>
              <td>Номер на лична карта</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('identityCardIssuer')">ЛК издадена от</button>
              </td>
              <td>Издател на лична карта</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('identityCardCreationDate')">ЛК издадена на</button>
              </td>
              <td>Дата на издаване на лична карта</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('identityCardExpirationDate')">ЛК валидна до</button>
              </td>
              <td>Дата до която е валидна личната карта</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('passportNumber')">Паспорт</button>
              </td>
              <td>Номер на паспорт</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('passportCreationDate')">Паспорт издадена на</button>
              </td>
              <td>Дата на издаване на паспорт</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('passportExpirationDate')">Паспорт валиден до</button>
              </td>
              <td>Дата до която е валиден паспорта</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('tripStartDate')">Пътуване начало</button>
              </td>
              <td>Дата на която започва пътуването</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('tripEndDate')">Пътуване край</button>
              </td>
              <td>Дата на която завършва пътуването</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('tripPrice')">Пътуване цена</button>
              </td>
              <td>Цена на пътуването</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('tripDeposit')">Пътуване капаро</button>
              </td>
              <td>Капаро за съответното пътуване</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('tripTitle')">Пътуване име</button>
              </td>
              <td>Име на пътуването, както е въведено в системата</td>
            </tr>
            <tr>
              <td>
                <button class="btn btn-secondary btn-micro" @click="copyTemplate('tripKey')">Пътуване код</button>
              </td>
              <td>Уникален код на пътуването, както е генериран от системата</td>
            </tr>
          </tbody>
        </table>
      </div>
    </vuestic-modal>
  </vuestic-widget>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { host } from "../../../services/http"; // TODO: Move to api
import { tripApi } from "../../../services/api/tripApi";
import { getIfNotNull, formatCurrency, dateLocale, copyTextToClipboard, fallbackCopyTextToClipboard } from "../../../utils";

export default {
  name: "trip-edit",
  props: {
    tripId: String
  },
  created() {
    tripApi.getTrip(this.tripId).then(tripData => {
      oldTripModel = { ...tripData };
      this.tripData = { ...tripData };
      this.startDate = tripData.startDate.format(dateLocale);
      this.currency = this.currencyList.find(item => item.id === tripData.currency) || { id: tripData.currency, name: tripData.currency };
      this.endDate = tripData.endDate.format(dateLocale);
      this.requireVisa = {
        label:
          tripData.requireVisa === 0
            ? this.$t("general.no")
            : this.$t("general.yes"),
        value: tripData.requireVisa
      };
      this.requirePassport = {
        label:
          tripData.requirePassport === 0
            ? this.$t("general.no")
            : this.$t("general.yes"),
        value: tripData.requirePassport
      };
      for (const item of this.destinationList) {
        if (item.id == tripData.destinationType) {
          this.destinationOption = item
        }
      } 
      console.log(tripData)
      for (const item of this.statusList) {
        if (item.id === tripData.status) {
          this.statusOption = item
        }
      }
      for (const item of this.parishList) {
        if (item.id === tripData.parish) {
          this.parishOption = item
        }
      }
      // if(this.statusOption === undefined) {
      //   this.statusOption = {id: 0, name: ""}
      // }

      this.$nextTick(() => {
        this.isTripLoaded = true
      })
    })
    this.debouncedUpdate = _.debounce(this.update, 3500);
  },
  watch: {
    tripData: {
      handler(tripModel) {
        if (this.isTripLoaded) {
          this.debouncedUpdate(tripModel);
        }
      },
      deep: true
    },
    startDate: {
      handler() {
        if (
          this.isTripLoaded &&
          this.startDate !== this.tripData.startDate.format(dateLocale)
        ) {
          this.tripData.startDate = moment(this.startDate, dateLocale);
        }
      }
    },
    endDate: {
      handler() {
        if (
          this.isTripLoaded &&
          this.endDate !== this.tripData.endDate.format(dateLocale)
        ) {
          this.tripData.endDate = moment(this.endDate, dateLocale);
        }
      }
    },
    requirePassport: {
      handler() {
        if (
          this.isTripLoaded &&
          this.requirePassport.value !== this.tripData.requirePassport
        ) {
          this.tripData.requirePassport = this.requirePassport.value;
        }
      }
    },
    requireVisa: {
      handler() {
        if (
          this.isTripLoaded &&
          this.requireVisa.value !== this.tripData.requireVisa
        ) {
          this.tripData.requireVisa = this.requireVisa.value;
        }
      }
    },
    destinationOption: {
      handler() {
        if (
          this.isTripLoaded &&
          this.destinationOption.id !== this.tripData.destinationType
        ) {
          this.tripData.destinationType = this.destinationOption.id
        }
      }
    },
    currency: {
      handler() {
        if (
          this.isTripLoaded &&
          this.currency.id !== this.tripData.currency
        ) {
          this.tripData.currency = this.currency.id;
        }
      }
    },
    statusOption: {
      handler () {
        this.errors.items = this.errors.items.filter(item => item.id !== '2000');
        if (
          this.isTripLoaded &&
          this.statusOption.id !== this.tripData.status
        ) {
          if (this.statusOption.id !== 2) {
            this.tripData.status = this.statusOption.id;
            return;
          }
          console.log("Endrolled", this.tripData.enrolled);
          console.log("participants", this.tripData.minimumParticipants);
          if (this.tripData.enrolled >= this.tripData.minimumParticipants) {
            this.tripData.status = this.statusOption.id;
          } else {
            this.showToast(`${this.$t('trip.edit.errorStatus')}`, {
              icon: 'fa-save',
              position: 'top-center'
            });
            this.errors.items = [
              {
                id: '2000',
                field: 'status',
                msg: this.$t('trip.edit.errorStatusValidation'),
                rule: 'required',
                scope: null
              }]
            console.log('Display error message. Don\'t do anything!');
          }
        }
      }
    },
    parishOption: {
      handler () {
        if (
          this.isTripLoaded &&
          this.parishOption.id !== this.tripData.parish
        ) {
          this.tripData.parish = this.parishOption.id
        }
      }
    },
    tripContractTemplateStorage: {
      handler() {
        if (this.isTripLoaded && this.tripContractTemplateStorage.length > 0) {
          let docUrl = null;
          tripApi
            .uploadDocument({
              documentType: 1,
              document: this.tripContractTemplateStorage[0]
            })
            .then(documentData => {
              docUrl = documentData.file;
              return tripApi.linkContract(this.tripId, documentData.id);
            })
            .then(res => {
              this.tripData.tripContractTemplate = docUrl;
              oldTripModel.tripContractTemplate = docUrl;
              this.showToast(`${this.$t('general.changesMade')}`, {
                icon: 'fa-save',
                position: 'top-center'
              });
            });
        }
      }
    },
    tripDetailsStorage: {
      handler() {
        if (this.isTripLoaded && this.tripDetailsStorage.length > 0) {
          let docUrl = null;
          tripApi
            .uploadDocument({
              documentType: 2,
              document: this.tripDetailsStorage[0]
            })
            .then(documentData => {
              docUrl = documentData.file;
              return tripApi.linkTripDetails(this.tripId, documentData.id);
            })
            .then(res => {
              this.tripData.tripDetails = docUrl;
              oldTripModel.tripDetails = docUrl;
              this.showToast(`${this.$t("general.changesMade")}`, {
                  icon: "fa-save",
                  position: "top-center"
                });
            });
        }
      }
    }
  },
  data () {
    return {
      tripData: {
        title: "",
        startDate: moment(),
        endDate: moment(),
        participants: "",
        price: "",
        deposit: "",
        destinationType: "",
        requirePassport: false,
        requireVisa: false,
        tripContractTemplate: null,
        tripDetails: null,
        parish: 0,
        enrolled: 0,
        currency: "BGN",
      },
      destinationOption: {},
      statusOption: {},
      parishOption: {},
      requirePassport: {},
      requireVisa: {},
      startDate: "",
      endDate: "",
      isTripLoaded: false,
      destinationList: [
        { id: "BG", name: "България" },
        { id: "EU", name: "EU" },
        { id: "OT", name: "Друго" }
      ],
      statusList: [
        { id: 0, name: "" },
        { id: 1, name: "Активно" },
        { id: 2, name: "Проведено" },
        { id: 3, name: "Непроведено" }
      ],
      parishList: [
        {id:1, name: '"Св. ап. Андрей Първозваний"'},
        {id:2, name: '"Свето Благовещение"  '},
        {id:3, name: '"Св. цар Борис" - кв. Овча купел'},
        {id:4, name: '"Св. Богородица - Животворен източник"'},
        {id:5, name: '"Въведение Богородично" - кв. Дружба'},
        {id:6, name: '"Въздвижение на Св.Кръст Господен"'},
        {id:7, name: '"Възнесение Господне" - кв. Ситняково'},
        {id:8, name: '"Възнесение Господне" - кв. Гниляне'},
        {id:9, name: '"Възкресение Христово"'},
        {id:10, name: '"Св. вмчк Георги" - Петте Кьошета'},
        {id:11, name: '"Св. вмчк Георги" - Ротонда'},
        {id:12, name: '"Св. вмчк Георги" - кв. Дървеница'},
        {id:13, name: '"Св. вмчк Георги" - кв. Горубляне'},
        {id:14, name: '"Св. вмчк Георги" - кв. Суходол'},
        {id:15, name: '"Св. вмчк Георги" - кв.Градоман, Банкя'},
        {id:16, name: '"Св. вмчк Димитър" - кв. Хаджи Димитър'},
        {id:17, name: '"Св. Дух" - кв. Надежда'},
        {id:18, name: '"Св. пророк Илия"- ж.к. Дружба'},
        {id:19, name: '"Св. пророк Илия" - кв. Княжево'},
        {id:20, name: '"Св. пророк Илия" - кв. Илиенци'},
        {id:21, name: '"Св. пророк Йеремия" - кв. Илиенци'},
        {id:22, name: '"Св. Йоан Богослов" - ж.к. Левски Г'},
        {id:23, name: '"Св. Йоан Кръстител" - кв. Обеля'},
        {id:24, name: 'СДС "Св. Йоан Рилски"'},
        {id:25, name: '"Св. Константин и Елена"'},
        {id:26, name: '"Св. Кирил и Методий" - кв. Красно село'},
        {id:27, name: '"Св. Кирил и Методий" - (на Женския пазар)'},
        {id:28, name: '"Св. Климент Охридски" - ж.к. Люлин'},
        {id:29, name: '"Св. вмчк Мина" - манастира'},
        {id:30, name: '"Св. вмчк Мина" - кв. Модерно предградие'},
        {id:31, name: '"Св. Наум Охридски" - ж.к. Дружба 1'},
        {id:32, name: '"Св. вмчца Неделя"'},
        {id:33, name: '"Св. Николай Мирликийски" - ул. Калоян'},
        {id:34, name: '"Св. Николай" - кв. Горна баня'},
        {id:35, name: '"Св. Николай" - кв. Връбница'},
        {id:36, name: '"Св. Николай" - кв. Враждебна'},
        {id:37, name: '"Св. Николай Мирликийски Летни" - кв. Бенковски'},
        {id:38, name: '"Св. мчк Николай Софийски" - ул. Пиротска'},
        {id:39, name: '"Св. вмчк Пантелеймон" кв. Бояна'},
        {id:40, name: '"Св. Петка" - старинен храм'},
        {id:41, name: '"Св. Петка" - кв. Орландовци'},
        {id:42, name: '"Св. Петка" - кв. Кремиковци'},
        {id:43, name: '"Св. мчца Параскева" - "ул. Г.С. Раковски"'},
        {id:44, name: '"Св. Петка (мчца Параскева) Самарджийска"'},
        {id:45, name: '"Св. ап. Петър и Павел"'},
        {id:46, name: '"Покров Богородичен"'},
        {id:47, name: '"Преображение Господне"'},
        {id:48, name: '"Рождество Богородично"'},
        {id:49, name: '"Рождество Богородично" - кв. Филиповци'},
        {id:50, name: '"Рождество на св. Йоан Кръстител" - кв. Обеля'},
        {id:51, name: '"Рождество Христово" - Младост 3'},
        {id:52, name: '"Св. Седмочисленици"'},
        {id:53, name: '"Св. София - Премъдрост Божия"'},
        {id:54, name: '"Св. Теодор Стратилат" - кв. Бенковски'},
        {id:55, name: '"Св. Троица"'},
        {id:56, name: '"Св. Троица" - кв. Редута'},
        {id:57, name: '"Св. Троица" - кв. Драгалевци'},
        {id:58, name: '"Св. Троица" - кв. Кубратово'},
        {id:59, name: '"Успение Богородично" - ул. Ручей'},
        {id:60, name: '"Успение Богородично" - кв. Малашевци'},
        {id:61, name: '"Успение Богородично" - кв. Обеля'},
        {id:62, name: 'Руски храм-подворие "Св. Николай"'},
        {id:63, name: '"Света Троица" - кв. Суходол'},
        {id:64, name: 'Румънски храм "Св. Троица"'},
      ],
      tripDetailsStorage: [],
      tripContractTemplateStorage: [],
      config: {
        tripDateFrom: {
          dateFormat: "d-m-Y"
        },
        tripDateTo: {
          dateFormat: "d-m-Y",
          locale: { firstDayOfWeek: 1 },
          minDate: null
        }
      },
      mandatoryOptions: [
        { label: this.$t("general.yes"), value: 1 },
        { label: this.$t("general.no"), value: 0 }
      ],
      currencyList: [
        { id: 'EUR', name: 'EUR' },
        { id: 'BGN', name: 'BGN' }
      ],
      currency: { id: 'EUR', name: 'EUR' },
    };
  },
  methods: {
    onTripDateFromChange(selectedDates, dateStr, instance) {
      this.$set(this.config.tripDateTo, "minDate", dateStr);
    },

    onTripDateToChange(selectedDates, dateStr, instance) {
      this.$set(this.config.tripDateFrom, "maxDate", dateStr);
    },

    update() {
      this.$validator.validateAll().then(() => {
        if (this.errors.any()) return true;
        Object.keys(this.tripData).forEach(key => {
          if (
            this.tripData[key] != oldTripModel[key] &&
            key != "tripContractTemplate" &&
            key != "tripDetails" 
          ) {
            tripApi
              .updateField(this.tripId, key, this.tripData[key])
              .then(() => {
                this.showToast(`${this.$t("general.changesMade")}`, {
                  icon: "fa-save",
                  position: "top-center"
                });
                oldTripModel[key] = this.tripData[key];
              })
              .catch(e=>console.log(e));
          }
        });
      });
    },

    downloadDocument(url) {
      const link = document.createElement("a");
      link.href = `${host}${url}`;
      link.setAttribute("download", "file.docx");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
    },

    showModal() {
      this.$refs.smallModal.open();
    },

    copyTemplate(name) {  
      copyTextToClipboard("{" + name + "}");
    },

    deleteFile(propertyName){
      this.tripData[propertyName] = null;
      this[propertyName+"Storage"] = [];
    }
  },
  computed: {
    tripCurrency() {
      return this.currency && this.currency.id ? this.currency.id.toLowerCase() : 'bgn';
    }
  },
};

let oldTripModel = {};
</script>

<style lang="scss">
.tripTitle {
  width: 1000px;
  padding-right: 50px;
}

.tripStatus {
  width: 180px;
}

.textInput {
  width: 100px;
}
.dropDownInput {
  width: 200px;
}

.participants {
  margin-right: 400px;
}

.minimumParticipants {
  width: 270px;
  margin-right: 220px;
}

.flex-evenly {
  display: flex;
  justify-content: space-between;
}

.tripParish {
  min-width: 400px;
}
</style>
